import Supplies from "../../components/Supplies/Supplies";

const SuppliesPage = () => {
  return <Supplies />;
};

export default SuppliesPage;
